import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=5aca08a8&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"
import style0 from "./message-list.vue?vue&type=style&index=0&id=5aca08a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca08a8",
  null
  
)

export default component.exports